module.exports = __webpack_public_path__ + "img/KIT_LOGO.4553b57e.png";